export default __webpack_public_path__ + "static/media/login-logo.dcb68e13.svg";